window.addEventListener("resize", () => {

    height = window.innerHeight

    if (window.innerWidth != width) {
        // width = window.innerWidth;
        // height = window.innerWidth;
        
    }


    fullheight.style.height = height + "px";



    

});
